/**
 * Per-app visibility types.
 * Mirrors backend models.py AppVisibilitySettings and the RTDB node
 * devices/{id}/config/appVisibility (see contracts/firebase-schema.md §2.4).
 *
 * Each key is one child-facing launcher entry of the CTube tablet app. When false, the
 * tablet hides the app's icon and closes it if it is running. Absent key = visible.
 */

export type AppKey = 'browser' | 'schedules' | 'talkingpal' | 'games';

export const APP_KEYS: AppKey[] = ['browser', 'schedules', 'talkingpal', 'games'];

export interface AppVisibilitySettings {
  browser: boolean;
  schedules: boolean;
  talkingpal: boolean;
  games: boolean;
  updatedAt?: number | null;
  updatedBy?: string | null;
}

export type AppVisibilitySettingsUpdate = Partial<Record<AppKey, boolean>>;

export const DEFAULT_APP_VISIBILITY_SETTINGS: AppVisibilitySettings = {
  browser: true,
  schedules: true,
  talkingpal: true,
  games: true,
};
